import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["className"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { useTheme } from '@emotion/react';
import clsx from 'clsx';
import { form } from '../assets/styles/utility';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesControlLabel = theme => _objectSpread(_objectSpread({
  position: 'absolute',
  top: theme.space.xsmall,
  left: 0,
  paddingLeft: form.variables(theme).controlOffset,
  paddingRight: form.variables(theme).controlOffset,
  width: '100%',
  pointerEvents: 'none'
}, theme.text.xsmall), {}, {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

const ControlLabel = _ref => {
  let {
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    className: clsx('CK__ControlWrapper', className),
    css: StylesControlLabel(theme)
  }, rest));
};

export default ControlLabel;